import {IWish} from "../wish/Helper";

export interface IAuthState {
    loggedInUser: ILoggedInUser
    login: ILoginState
    register: IRegisterState
    updateUserLoading: boolean
    changeLocaleLoading: boolean
}

export interface ILoggedInUser {
    id: string
    access_token: string
    token_type: string
    email: string
    full_name: string
    city: string
    address: string
    gender: string
    phone_number: string
    created_at: string
    is_admin: boolean
    client_id: string | null
    points: number
    available_points: number
    profile_picture: string
    default_locale: string
    has_spin_today: string | null
    subscribed: boolean
}


export const initialLoggedInUserState: ILoggedInUser = {
    id: '',
    access_token: "",
    token_type: "bearer",
    email: "",
    full_name: "",
    city: "",
    address: "",
    phone_number: "",
    gender: "",
    created_at: "",
    is_admin: false,
    client_id: null,
    points: 0,
    available_points: 0,
    profile_picture: '',
    default_locale: '',
    has_spin_today: null,
    subscribed: false
}

export const initialRegisterState: IRegisterState = {
    error: false,
    loading: false,
    success: false,
    message: ""
}

export const initialLoginState: ILoginState = {
    error: false,
    loading: false,
    errorMessage: ""
}

export interface IRegisterUserBody {
    email: string
    name: string // We don't send this to backend
    surname: string // We don't send this to backend
    full_name: string
    password: string
    phone_number?: string
    subscribed: boolean
}

export interface IRegisterState {
    success: boolean
    loading: boolean
    error: boolean,
    message: string
}

export interface ILoginState {
    loading: boolean
    error: boolean
    errorMessage: string
}

export interface IObtainEntriesAction {
    qty: number
    wish: IWish
}


